import { AppHelper } from "../appHelper"
import { Grid } from "../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { RSplitter, RSplitterDirection } from "../core/components/rSplitter";
import { EntityServiceReportTimeHorizontal } from "../serviceReport/serviceReportUtil";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class LocksApp extends React.Component<AppBaseProps, any> {
    private _satzSperreGridData: Array<any> = [];
    private _recordioGridData: Array<any> = [];
    private _reportLockGridData: Array<any> = [];
    private _satzSperreGridRef: Grid;
    private _recordioGridRef: Grid;
    private _selectedSatzSperreItems: any;
    private _selectedRecordioItems: any;
    private _selectedReportLockItems: any;
    private _editSatzSperreEnabled: boolean = false;
    private _editRecordioEnabled: boolean = false;
    private _reportLockEnabled: boolean = false;
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string>;
    satzSperreGridOptions: kendo.ui.GridOptions;
    recordioGridOptions: kendo.ui.GridOptions;
    reportLockGridOptions: kendo.ui.GridOptions;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this._load();
    }

    private _getSatzSperreGridData = () => {
        return HTTPService.get<JsonResultClass<[]>>("Locks/GetSatzSperreGridData")
            .then(result => {
                Helper.setArrayValues(this._satzSperreGridData, result.Data);
            });
    }

    private _getRecordioGridData = () => {
        return HTTPService.get<JsonResultClass<[]>>("Locks/GetRecordioGridData")
            .then(result => {
                Helper.setArrayValues(this._recordioGridData, result.Data);
            });
    }

    private _getReportLockGridData = () => {
        return HTTPService.get<JsonResultClass<[]>>("Locks/GetReportLocksGridData")
            .then(result => {
                Helper.setArrayValues(this._reportLockGridData, result.Data);
            });
    }

    private _load = () => {
        $.when(this._getSatzSperreGridData(), this._getRecordioGridData(), this._getReportLockGridData()).then(() => {
            this.setState({});
        });
    }

    private _satzSperreSelectionChanged = (dataItem) => {
        const prevEditEnabled = this._editSatzSperreEnabled;
        this._editSatzSperreEnabled = Helper.hasValue(dataItem);
        this._selectedSatzSperreItems = dataItem;
        if (prevEditEnabled !== this._editSatzSperreEnabled) {
            this.setState({});
        }
    }

    private _recordioSelectionChanged = (dataItem) => {
        const prevEditEnabled = this._editRecordioEnabled;
        this._editRecordioEnabled = Helper.hasValue(dataItem);
        this._selectedRecordioItems = dataItem;
        if (prevEditEnabled !== this._editRecordioEnabled) {
            this.setState({});
        }
    }

    private _reportLockSelectionChanged = (dataItem) => {
        const prevEditEnabled = this._reportLockEnabled;
        this._reportLockEnabled = Helper.hasValue(dataItem);
        this._selectedReportLockItems = dataItem;
        if (prevEditEnabled !== this._reportLockEnabled) {
            this.setState({});
        }
    }

    private _removeSatzSperreEntries = (dataItems) => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                if (!(dataItems instanceof Array))
                    dataItems = [dataItems];
                HTTPService.post<JsonResultClass>("Locks/DeleteSatzSperreEntries", dataItems)
                    .then((data) => {
                        if (data.Code == 0)
                            this._load();
                        else
                            NotificationHelper.showErrorMessage(this.translations["WebSMS.Locks.DeleteError"]);
                    });
            }
        });
    }

    private _removeRecordioEntries = (dataItems) => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOK => {
            if (isOK) {
                if (!(dataItems instanceof Array))
                    dataItems = [dataItems];
                HTTPService.post<JsonResultClass>("Locks/DeleteRecordioEntries", dataItems)
                    .then((data) => {
                        if (data.Code == 0)
                            this._load();
                        else
                            NotificationHelper.showErrorMessage(this.translations["WebSMS.Locks.DeleteError"]);
                    });
            }
        });
    }

    private _removeReportLockEntries = (dataItems) => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOK => {
            if (isOK) {
                if (!(dataItems instanceof Array))
                    dataItems = [dataItems];
                HTTPService.post<JsonResultClass>("Locks/DeleteReportLocksEntries", dataItems.map(x => x.IsGuid))
                    .then((data) => {
                        if (data.Code == 0)
                            this._load();
                        else
                            NotificationHelper.showErrorMessage(this.translations["WebSMS.Locks.DeleteError"]);
                    });
            }
        });
    }

    private _handleSatzSperreDeleteButtonClick = (type: ToolBarStandardButtonType, dataItem: EntityServiceReportTimeHorizontal) => {
        if (type === ToolBarStandardButtonType.DELETE) {
            this._removeSatzSperreEntries(dataItem);
        }
        else {
            if (type === ToolBarStandardButtonType.RELOAD) {
                this._getSatzSperreGridData().then(() => {
                    this.setState({});
                });
            }
        }
    }

    private _handleRecordioDeleteButtonClick = (type: ToolBarStandardButtonType, dataItem: EntityServiceReportTimeHorizontal) => {
        if (type === ToolBarStandardButtonType.DELETE) {
            this._removeRecordioEntries(dataItem);
        }
        else {
            if (type === ToolBarStandardButtonType.RELOAD) {
                this._getRecordioGridData().then(() => {
                    this.setState({});
                });
            }
        }
    }

    private _handleReportLockButtonClick = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.DELETE) {
            this._removeReportLockEntries(dataItem);
        }
        else if (type === ToolBarStandardButtonType.RELOAD) {
            this._getReportLockGridData().then(() => {
                this.setState({});
            });
        }

    }

    createGrids = () => {
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.RELOAD, caption: Config.translations.reloadLabel, enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.delete, enabled: this.props.entity.RecordRight.CanWrite }
        ];
        const recordioGrid = this._recordioGridData.length > 0 ?
            (<>
                <div className="flex-container__item flex-containter" >
                    <Grid data={this._recordioGridData}
                        options={this.recordioGridOptions}
                        id="recordIOGrid"
                        onSelectionChanged={this._recordioSelectionChanged}
                        ref={(r) => this._recordioGridRef = r}
                        standardButtons={standardButtons}
                        onClickStandardButton={this._handleRecordioDeleteButtonClick}
                    />
                </div>
            </>) : null;

        const satzSperreGrid = (
            <>
                <div className="flex-container__item flex-containter" >
                    <Grid data={this._satzSperreGridData}
                        options={this.satzSperreGridOptions}
                        id="satzSperreGrid"
                        onSelectionChanged={this._satzSperreSelectionChanged}
                        ref={(r) => this._satzSperreGridRef = r}
                        standardButtons={standardButtons}
                        onClickStandardButton={this._handleSatzSperreDeleteButtonClick}
                    />
                </div>
            </>);

        return (
            <div className="flex-container">
                <RSplitter direction={RSplitterDirection.Vertical} initialPercentage={50}>
                    {satzSperreGrid}
                    {recordioGrid}
                </RSplitter>
            </div>
        );
    }

    createReportGrid = () => {
        if (this._reportLockGridData == null)
            return null;

        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.RELOAD, caption: Config.translations.reloadLabel, enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.delete, enabled: this.props.entity.RecordRight.CanWrite }
        ];

        return <div className="flex-container__item flex-containter" >
            <Grid data={this._reportLockGridData}
                options={this.reportLockGridOptions}
                standardButtons={standardButtons}
                onClickStandardButton={this._handleReportLockButtonClick}
                onSelectionChanged={this._reportLockSelectionChanged}
                id="reportLockGrid"
            />
        </div>
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
};
